// extracted by mini-css-extract-plugin
export var blink = "_8q-2";
export var cursor = "_8q-1";
export var reactMarkdown = "_8q-3";
export var streamingText = "_8q-0";